import { motion } from 'framer-motion';

import { MENTORS_ROW_1, MENTORS_ROW_2 } from './mentorsMarqueeData';
import MentorCard from './mentorCard';
import MarqueeRow from './marqueeRow';

const MentorsMarquee = () => {
  return (
    <div className="flex flex-col items-center bg-white sm:py-20 py-10 gap-10">
      <div className="flex flex-col items-center gap-3 w-full max-w-[1120px] sm:px-10 px-5">
        <motion.div
          className="relative inline-block text-[24px] leading-9 sm:text-[40px] sm:leading-[64px] tracking-[0.04em] text-center text-[#020617] font-gilroy-bold"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          Learn with Industry
          <br className="sm:hidden" /> Experienced Mentors
          <svg
            width="546"
            height="18"
            viewBox="0 0 546 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute right-0 -bottom-1 sm:-bottom-2 w-[84%] sm:w-[51.5%] h-auto"
          >
            <motion.path
              d="M176.505 3.00208C173.355 3.47538 157.785 3.00215 154.005 3.00215C149.28 3.00215 4.58344 2.6445 3.00848 11.1638C1.74852 17.9793 362.148 11.2366 543.005 11"
              stroke="#FCD34D"
              strokeWidth="6"
              strokeLinecap="round"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1.2, ease: 'easeInOut', delay: 0.3 }}
            />
          </svg>
        </motion.div>
      </div>
      <div className="flex flex-col gap-4 sm:gap-6 w-full">
        <MarqueeRow items={MENTORS_ROW_1} direction="left" gap={16} renderItem={(mentor) => <MentorCard {...mentor} />} />
        <MarqueeRow items={MENTORS_ROW_2} direction="right" gap={16} renderItem={(mentor) => <MentorCard {...mentor} />} />
      </div>
    </div>
  );
};

export default MentorsMarquee;
